<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <img src="@/assets/logo.svg" alt="girlboyshop" class="logo-image">
          <p>Your one-stop shop for trendy men's and women's clothing in Pakistan.</p>
          <div class="social-icons">
            <a href="#" class="social-icon"><i class="fab fa-facebook-f"></i></a>
            <a href="#" class="social-icon"><i class="fab fa-instagram"></i></a>
            <a href="#" class="social-icon"><i class="fab fa-twitter"></i></a>
            <a href="#" class="social-icon"><i class="fab fa-pinterest"></i></a>
          </div>
        </div>

        <div class="footer-section">
          <h3>Quick Links</h3>
          <ul class="footer-links">
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/products?category=men">Men's Collection</router-link></li>
            <li><router-link to="/products?category=women">Women's Collection</router-link></li>
            <li><router-link to="/contact">Contact Us</router-link></li>
          </ul>
        </div>

        <div class="footer-section">
          <h3>Customer Service</h3>
          <ul class="footer-links">
            <li><a href="#">Shipping Policy</a></li>
            <li><a href="#">Return Policy</a></li>
            <li><a href="#">Privacy Policy</a></li>
            <li><a href="#">Terms of Service</a></li>
          </ul>
        </div>

        <div class="footer-section">
          <h3>Contact Info</h3>
          <p><i class="fas fa-envelope"></i> girlboyshop@girlboyshop.online</p>
          <div class="payment-methods">
            <img src="@/assets/images/easypaisa.png" alt="EasyPaisa" class="payment-icon">
            <img src="@/assets/images/jazzcash.png" alt="JazzCash" class="payment-icon">
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>Copyright © {{ new Date().getFullYear() }} Apparel Store. Powered by INSPIRINNO TECH NOLOGIES PRIVATE LIMITE</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped>
.site-footer {
  background-color: #333;
  color: #fff;
  padding: 50px 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-bottom: 30px;
}

.footer-section h3 {
  color: #fff;
  font-size: 18px;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}

.footer-section h3::after {
  content: '';
  position: absolute;
  width: 40px;
  height: 2px;
  background-color: #4CAF50;
  bottom: 0;
  left: 0;
}

.footer-section p {
  margin-bottom: 15px;
  line-height: 1.6;
  color: #bbb;
}

.social-icons {
  display: flex;
  margin-top: 20px;
}

.social-icon {
  background-color: rgba(255, 255, 255, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  color: #fff;
  transition: all 0.3s ease;
}

.social-icon:hover {
  background-color: #4CAF50;
}

.footer-links {
  list-style: none;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: #bbb;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #4CAF50;
}

.footer-section i {
  margin-right: 10px;
  color: #4CAF50;
}

.payment-methods {
  display: flex;
  align-items: center;
  margin-top: 15px;
}

.payment-icon {
  height: 30px;
  margin-right: 10px;
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom p {
  color: #bbb;
  font-size: 14px;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .footer-section h3::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .social-icons {
    justify-content: center;
  }
}
</style>
